// extracted by mini-css-extract-plugin
export default {"icons":"Socials_icons__zlQ+X","icon":"Socials_icon__Mpxv7"};